import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Response from '../views/Response.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/response/',
    name: 'response',
    component: Response
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
